import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getSettlementById } from "../services/adminApi";

import SettlementSummary from "../components/settlements/SettlementSummary";
import SettlementTimeline from "../components/settlements/SettlementTimeline";
import SettlementPreview from "../components/settlements/SettlementPreview";

import "../styles/Settlements.css";

const SettlementDetails = () => {

    const { id } = useParams();

    const [settlement, setSettlement] = useState(null);

    useEffect(() => {

        loadSettlement();

    }, []);

    const loadSettlement = async () => {

        try{

            const res = await getSettlementById(id);

            setSettlement(res.data.settlement);

        }catch(err){

            console.error(err);

        }

    };

    if(!settlement){

        return <p>Loading...</p>;

    }

    return(

        <div className="settlement-details">

            <SettlementPreview settlement={settlement}/>

            <SettlementSummary settlement={settlement}/>

            <SettlementTimeline settlement={settlement}/>

        </div>

    );

};

export default SettlementDetails;